import { render } from "./MobileIframeViewer.vue?vue&type=template&id=373877d6&scoped=true"
import script from "./MobileIframeViewer.vue?vue&type=script&lang=js"
export * from "./MobileIframeViewer.vue?vue&type=script&lang=js"

import "./MobileIframeViewer.vue?vue&type=style&index=0&id=373877d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373877d6"]])

export default __exports__